import { ButtonUpdate } from '../../Form/Buttons/ButtonUpdate.js';
import { FormDelete } from '../../Form/FormDelete.js';

export const Attraction = (props) => {
    const { entity, datas } = props;
    return (
        <div className="admin-list">
            <div className="title">
                <div>{`ADMIN: ${entity} (${datas.length})`}</div>
            </div>
            <div className="thead">
                <div className="block-rows">
                    <div className="id">id</div>
                    <div className="item-status">status</div>
                    <div className="name">name</div>
                </div>
                <div className="block-buttons"></div>
            </div>
            {datas.map((el, i) => {
                let status_label = el.status ? el.status : 'Null';
                let color = status_label === 'Enable' ? 'valide' : 'error';
                return (
                    <div key={i} className="rows">
                        <div className="block-rows">
                            <div className="id">{el.id}</div>
                            <div className="item-status">
                                <div className={`status ${color}`}>{status_label}</div>
                            </div>
                            <div className="item">{el.name}</div>
                        </div>
                        <div className="block-buttons">
                            <ButtonUpdate entity={entity} id={el.id} />
                            <FormDelete entity={entity} id={el.id} />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}